import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AuthService} from './service/auth/auth.service';
import {RouterGuardService} from './guard/router-guard/router-guard.service';
import {ConstantService} from './constant/constant.service';
import {PartnerService} from './service/partner/partner.service';
import {SpinnerComponent} from './spinner/spinner.component';
import {LoanService} from './service/loan/loan.service';
import {RangePipe} from './pipe/pipe/range.pipe';
import {UrlDataPipe} from './pipe/url-data.pipe';
import {LoanApplicationCustomerResolverService} from './resolver/loanApplicationCustomerResolver/loan-application-customer-resolver.service';
import {StateTransitionsCustomerService} from './helper/stateTransitions/state-transitions.customer.service';
import {ConnectionService} from './service/connection/connection.service';
import {ChatAssistantComponent} from './common-components/chat-assistant/chat-assistant.component';
import { CompileDirective } from './directives/compile.directives';

@NgModule({
  imports: [CommonModule],
  declarations: [
    SpinnerComponent, 
    ChatAssistantComponent,
    RangePipe, 
    UrlDataPipe,
    CompileDirective
  ],
  exports: [
    SpinnerComponent, 
    ChatAssistantComponent,
    RangePipe, 
    UrlDataPipe 
  ],
  providers: [
    AuthService,
    RouterGuardService,
    ConstantService,
    PartnerService,
    LoanService,
    LoanApplicationCustomerResolverService,
    StateTransitionsCustomerService,
    ConnectionService
  ]
})
export class SharedComponentModule {

}
